import { useFormContext, Controller } from "react-hook-form";
import { IconButton, InputAdornment, TextField, TextFieldProps, Tooltip } from "@mui/material";
import { FC, forwardRef, useState } from "react";
import Iconify from "../Iconify";

interface IProps {
    name: string;
    tooltip?: string;
    password?: boolean;
    externalError?: boolean;
    externalHelperText?: string;
}

const RHFTextField: FC<IProps & TextFieldProps> = forwardRef(
    ({ name, tooltip, password, externalError, externalHelperText, ...other }, ref) => {
        const { control } = useFormContext();
        const [showPassword, setShowPassword] = useState(false);

        return (
            <Controller
                name={name}
                control={control}
                render={({ field, fieldState: { error } }) => (
                    <TextField
                        fullWidth
                        error={!!error || !!externalError}
                        type={password ? (showPassword ? "text" : "password") : undefined}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            endAdornment: (
                                <>
                                    {password ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowPassword(!showPassword)}
                                                edge="end"
                                            >
                                                <Iconify
                                                    icon={
                                                        showPassword
                                                            ? "eva:eye-fill"
                                                            : "eva:eye-off-fill"
                                                    }
                                                />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : undefined}
                                    {tooltip ? (
                                        <InputAdornment position="end">
                                            <Tooltip title={tooltip || ""}>
                                                <IconButton edge="end">
                                                    <Iconify icon="eva:info-fill" />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    ) : undefined}
                                </>
                            ),
                        }}
                        {...field}
                        {...other}
                        value={field.value || ""}
                        placeholder={other.placeholder}
                        helperText={error?.message || externalHelperText || other.helperText}
                        inputRef={ref}
                    />
                )}
            />
        );
    }
);

export default RHFTextField;
